import { lazy } from "react";

const routes = [
  {
    path: "/branch",
    element: lazy(() => import("../pages/Branch")),
  },
  {
    path: "/branch/add",
    element: lazy(() => import("../pages/Branch/create")),
  },
  {
    path: "/branch/edit/:id",
    element: lazy(() => import("../pages/Branch/edit")),
  },
];

export default routes;
